import classes from './VideoTutorial.module.scss';

export default function VideoTutorial(props) {
    /**
     * return null needed for react render func
     */
    if (!props) return null;

    const data = props.data[0];

    return (
        <div className={classes.oVideoSectionBlock}>
            <div className={`container`}>
                <div className={`row no-gutters`}>
                    <h2 className={`${classes.aBlockTitle} aSectionTitle fntH2`}>{data.title}</h2>
                </div>
                <div className={`row`}>
                    <div className={`${classes.oVideoContainer} col`}>
                        <iframe
                            className={classes.iFrame}
                            src={data?.video?.data?.attributes?.url}
                            allow="fullscreen"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
}
